module.exports = __webpack_public_path__ + "static/media/editpen-icon.5e3c6292.svg";